import React from 'react';

const HEX_RE = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i;

const hexToRgb = (value) => {
  const match = String(value || '').trim().match(HEX_RE);
  if (!match) return null;
  return {
    r: parseInt(match[1], 16),
    g: parseInt(match[2], 16),
    b: parseInt(match[3], 16),
  };
};

const isLightColor = (value) => {
  const rgb = hexToRgb(value);
  if (!rgb) return false;
  const luminance = (0.2126 * rgb.r + 0.7152 * rgb.g + 0.0722 * rgb.b) / 255;
  return luminance > 0.72;
};

const getBadgeAccent = (profile, fallback) => {
  const candidates = [
    profile?.accent_color,
    profile?.button_color,
    profile?.title_color,
    profile?.bg_color,
  ];

  const accent = candidates.find((color) => (
    color &&
    !String(color).includes('transparent') &&
    !isLightColor(color)
  ));

  return accent || fallback;
};

const VerifiedBadge = ({ profile, size = 20, className = '', title = 'Verified profile', onClick }) => {
  const accent = getBadgeAccent(profile, '#2563eb');
  const lightAccent = isLightColor(accent);
  const checkColor = lightAccent ? '#0f172a' : '#ffffff';
  const ringColor = lightAccent ? 'rgba(15, 23, 42, 0.18)' : 'rgba(255, 255, 255, 0.88)';

  return (
    <span
      onClick={onClick}
      className={`inline-flex shrink-0 items-center justify-center rounded-full align-middle ${onClick ? 'cursor-pointer hover:scale-105 transition-transform' : ''} ${className}`}
      title={title}
      aria-label={title}
      style={{
        width: size,
        height: size,
        background: accent,
        color: checkColor,
        boxShadow: `0 0 0 2px ${ringColor}, 0 5px 14px rgba(15, 23, 42, 0.22)`,
      }}
    >
      <svg
        viewBox="0 0 20 20"
        aria-hidden="true"
        style={{ width: Math.round(size * 0.62), height: Math.round(size * 0.62) }}
        fill="none"
      >
        <path
          d="M5.2 10.2 8.3 13.3 14.9 6.7"
          stroke="currentColor"
          strokeWidth="2.6"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </span>
  );
};

export default VerifiedBadge;
